var Glyphicon = require("components/utility/icons/Glyphicon");
import { Link } from "react-router-dom";

require("users/teachers/upgrade/upgrade_header.scss");

class UpgradeHeader extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	subHeaderList() {
		return _.map(UpgradeHeader.BENEFITS[this.props.product], (benefitText) => {
			return (
				<div className="benefitItem" key={ benefitText }>
					<Glyphicon icon="ok" />
					<div className="benefitText">{ benefitText }</div>
				</div>
			);
		});
	}

	render() {
		var headerClassName = "upgradeHeader " + this.props.product + "Header";

		if (this.props.showSkipOption) {
			var skipToOnboarding = (
				<div className="laterWrap">
					<Link to="/" className="laterLink">Upgrade Later</Link>
				</div>
			);
		}

		return (
			<div className={ headerClassName }>
				<div className="container headerContainer">
					<div className="subHeader headerText">
						Upgrade to { $wr.capitalize(this.props.product) }
					</div>
					<div className="benefitsList">
						{ this.subHeaderList() }
					</div>
					{ skipToOnboarding }
				</div>
			</div>
		);
	}

};

UpgradeHeader.BENEFITS = {
	silver: [
		"Differentiation",
		"Writing data",
		"Reading accountability",
	],
	gold: [
		"Identify which students demonstrate comprehension",
	    "Differentiate and customize scaffolds for each student",
	    "Track students’ daily reading using a digital reading log",
	    "Encourage students to read within their ZPD reading level",
	    "Activate standards-aligned questions and reporting",
	    "Customize activities assigned alongside specific titles",
	    "Track reading and writing skills where support is needed",
	    "Assign intervention exercises based on student need",
	    "Observe reading and writing proficiency over time",
	],
};

UpgradeHeader.propTypes = StrictPropTypes({
	product: PropTypes.string.isRequired,
	showSkipOption: PropTypes.bool
});

module.exports = UpgradeHeader;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/upgrade/UpgradeHeader.js